<template>
<div class="chatroute-wrap">
<div style="flex: 1;">
    <div v-for="(item, index) in platforms" :key="index">
      <component ref="platElem" v-show="item.name == platform" :is="item.component"></component>
    </div>
</div>
  <div class="right-sidebar">
  <div class="icon-list aplus-auto-exp" data-spm="seller_layout_icon_list" data-aplus-ae="x1_1b3cd255" data-spm-anchor-id="a1zawg.17752401.navi_right_sidebar.seller_layout_icon_list.6b614edfOSUesN" data-spm-max-idx="1">
    <div class="top-icon-list">
      
      <div class="new-layout-icon">
        <div class="im-warpper">
          
          <div class="plat-btn">
            <Badge style="position: absolute;" :count="lazada_unread_count">
            </Badge>
            <div @click="selectPlatform('lazada')" class="im-icon" :class="{'active': platform=='lazada'}" aria-haspopup="true" aria-expanded="false">
                  <img src="~@/static/img/lazada/logo.jpg">
            </div>
          </div>
          <div class="plat-btn">
            <Badge style="position: absolute;" :count="shopee_unread_count">
            </Badge>
            <div @click="selectPlatform('shopee')" class="im-icon" :class="{'active': platform=='shopee'}" aria-haspopup="true" aria-expanded="false">
                    <img src="~@/static/img/shopee/logo.jpg">
            </div>
          </div>
        </div>

      </div>
      
    </div>

    <div class="bottom-icon-list">
      <!-- <Dropdown>
        <a href="javascript:void(0)">
          <Icon size="35" color="#07f" type="md-apps" />
        </a>
        
        <DropdownMenu slot="list">
            <DropdownItem @click.native="showKnowledgeModal">知识</DropdownItem>
        </DropdownMenu>
    </Dropdown> -->
    </div>
    
    <Modal :style="{height: '80%'}"
        v-model="knowledgeModal"
        title="知识"
        :footer-hide="footerHide"
        width="80%"
        >
        <Knowledge ref="knowledgeElem"></Knowledge>
    </Modal>

     <Modal :style="{height: '80%'}"
        v-model="saleServiceModal"
        title="售前售后"
        :footer-hide="footerHide"
        width="80%"
        >
        <saleService ref="saleServiceElem"></saleService>
    </Modal>
    
  </div>
  <div class="sidebar-portals aplus-auto-exp" data-spm="seller_layout_feedback" data-aplus-ae="6" data-spm-anchor-id="a1zawg.17752401.navi_right_sidebar.seller_layout_feedback.6b614edfOSUesN">
    <div class="sidebar-portals-content">
      <div></div>
    </div>
  </div>
  <PreviewImg @previewImgHide="previewImgHide" v-show="previewImgurl" :img="previewImgurl"></PreviewImg>
</div>

</div>

</template>
<script>
import saleService from "@/views/saleser/saleService.vue";
import Knowledge from "../components/knowledge.vue";
import conf from "../conf";
import EventBus from "../../../utils/eventBus";
import PreviewImg from "../components/previewImg.vue";
import LazadaChat from "./lazada/chatBox.vue";
import ShopeeChat from "./shopee/chatBox.vue";
import RequestUtils from "@/utils/RequestUtils";

export default {
  components: {
    Knowledge,
    saleService,
    PreviewImg,
    LazadaChat,
    ShopeeChat
  },
  data() {
    return {
      user: {},
      modal: false,
      platform: '',
      searchModal: false,
      knowledgeModal: false,
      saleServiceModal: false,
      footerHide: true,
      previewImgurl: false
    };
  },
  computed: {
    platforms: {
      get: function() {
        return conf.platforms;
      }
    },
    shopee_unread_count: {
      get() {
        let unread_count = 0;
        for (let k in this.$store.state.shopee.storeList) {
          unread_count += this.$store.state.shopee.storeList[k].unread_count;
        }
        return unread_count;

      }
    },
    lazada_unread_count: {
      get() {
        let unread_count = 0;
        for (let k in this.$store.state.lazada.storeList) {
          unread_count += this.$store.state.lazada.storeList[k].unread_count;
        }
        return unread_count;

      }
    }
  },
  methods: {
    // previewImgurl () {
    //   return 'https://th-live.slatic.net/p/66a840cae79f0d5b776af9470b8da15a.jpg';
    // },
    socketInit() {
      let self = this;
      RequestUtils.request(conf.wsInitialize())
      .then(function (data) {
        RequestUtils.webSocketOperation(self, conf.getWsUrl()+'?driver=LazadaChat,ShopeeChat&token='+data.token);
      })
    },
    getChildUser() {
      let param = new FormData();
      RequestUtils.request(conf.getChildUser(), param)
      .then((json) => {            
        this.$store.commit("setChildUser", json);
      })
    },
    clearData() {
      this.$store.commit("lazada/clear");
      this.$store.commit("shopee/clear");
    },

    selectPlatform (plat) {
      conf.setPlatform(plat);
      this.platform = conf.platform;
    },
    
    showKnowledgeModal () {
      this.knowledgeModal = true;
    },

    previewImgHide() {
      this.previewImgurl = false;
    }
  },
  created: function() {
    let self = this;
    this.platform = conf.platform;
    // this.$router.push({
    //   path: "/chat/"+this.platform,
    //   params: {}
    // });
    // this.clearData();
    // this.getChildUser();
    // this.socketInit();
    EventBus.$on('knowledgeModalEvent', () => {
      this.knowledgeModal = true;
      this.$refs.knowledgeElem.getKnowCate();
    })
    EventBus.$on('saleServiceModalEvent', () => {
      this.saleServiceModal = true;
      this.$refs.saleServiceElem.refresh();
    })
    EventBus.$on('openSession', () => {
      this.saleServiceModal = false;
    })
    EventBus.$on('previewImg', (args) => {
      self.previewImgurl = args;
    })
    EventBus.$on('setPlatform', (args) => {
      this.selectPlatform(args);
    })
  },
  mounted: function() {}
};
</script>
<style lang="scss">
@import "@/static/styles/theme.scss";
@import "@/static/styles/v-im.scss";

.chatroute-wrap {
  display: flex;
  flex-direction: row;

  .right-sidebar {
    z-index: 1;
    top: 0;
    right: 0;
    min-width: 64px;
    background: #fff;
    display: flex;
    flex-direction: row;
    box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);;

    .icon-list {
      width: 64px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border-right: 1px solid rgba(0,0,0,.1);

      .bottom-icon-list {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 3rem;
      }

      .im-warpper {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin-top: 52px;
        flex-direction: column;
        a {
          width: 100%;
        }

        .im-icon {
          cursor: pointer;
          width: 100%;
          text-align: center;
          padding: 1rem;

          img {
            height: 35px;
          }
        }
        .im-icon.active {
          background-color: rgba(0, 29, 233, 0.06);
        }
      }
    }
  }
}
</style>
